"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./TagsComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TagsComponent = function TagsComponent(_ref) {
  var text = _ref.text,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag pointer-cursor ".concat(className),
    onClick: onClick
  }, text);
};

var _default = TagsComponent;
exports["default"] = _default;